import gsap from "gsap";
import { DrawSVGPlugin, ScrollTrigger, ScrollSmoother } from "gsap/all";
import DefaultBlock from "/scripts/default/block";
import { watchPreferredMotion } from "/utils/helpers/watchPreferredMotion";

// Register Plugins
gsap.registerPlugin(DrawSVGPlugin, ScrollTrigger, ScrollSmoother);

export default class ScrollSeamless extends DefaultBlock {
	// Define variables
	init() {
		const selector = gsap.utils.selector(this.block);

		const DOM = {
			block: this.block,
			rectangle: selector("#seamless-rectangle-svg"),
			rectangleHole: this.block.querySelectorAll(
				".scroll-seamless__svg-masks--square"
			),
			oval: selector("#seamless-oval-svg"),
			ovalHole: this.block.querySelectorAll(
				".scroll-seamless__svg-masks--oval"
			),
			wrapper: selector("#scroll-seamless__svgs-wrapper"),
		};
		this.DOM = DOM;

		this.defaults = {
			ease: "power2.in",
			duration: 3,
		};

		this.tl = this.createTimeline();
	}

	scrollTrigger() {
		const tl = gsap.timeline({
			defaults: this.defaults,
			scrollTrigger: {
				trigger: this.DOM.wrapper,
				start: "top 50%",
				end: "bottom 40%",
				scrub: 1.5,
			},
		});

		tl.to(this.DOM.rectangle, { y: 800 });
		tl.to(this.DOM.rectangleHole, { scale: 0, ease: "back.in(1.7)" }, "<=1");
		tl.to(this.DOM.oval, { y: 800 }, 0.5);
		tl.to(this.DOM.ovalHole, { scale: 0, ease: "back.in(1.7)" }, "<=1");
	}

	createTimeline() {
		const tl = gsap.timeline({
			id: "scroll-seamless",
			defaults: this.defaults,
		});

		// tl.set(this.DOM.track, { autoAlpha: 1 });

		const mm = gsap.matchMedia();

		watchPreferredMotion(() => {
			this.scrollTrigger();
		});

		return tl;
	}
}
